import { render, staticRenderFns } from "./trees.vue?vue&type=template&id=38ae41c7&scoped=true&"
import script from "./trees.vue?vue&type=script&lang=js&"
export * from "./trees.vue?vue&type=script&lang=js&"
import style0 from "./trees.vue?vue&type=style&index=0&id=38ae41c7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ae41c7",
  null
  
)

export default component.exports